import { SVGProps } from "react";

export default function AddCircleOrangeIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 16, width = 16, stroke = "#FF6929", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8 10.6663V5.33301"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99219 8H10.6655"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33594 8H7.87594"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.66927 3.99967C1.83594 5.11301 1.33594 6.49967 1.33594 7.99967C1.33594 11.6797 4.3226 14.6663 8.0026 14.6663C11.6826 14.6663 14.6693 11.6797 14.6693 7.99967C14.6693 4.31967 11.6826 1.33301 8.0026 1.33301C7.04927 1.33301 6.13594 1.53301 5.31594 1.89967"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
